import { gql } from '@apollo/client';

export interface IHostGroupsResponse {
  hostsOverview: Array<{
    id: number;
    alias: string;
    position?: number;
    group_id: number;
    in_service: boolean;
    client_sessions: Array<{ id: number }>;
  }>;
  hostGroupsOverview: Array<{
    id: number;
    title: string;
    priority: number;
  }>;
}
export const CHANGE_HOSTS_DATA = gql`
  query changeHostsData {
    hostGroupsOverview {
      id
      title
      priority
    }
    hostsOverview {
      id
      position
      alias
      group_id
      in_service
      client_sessions {
        id
      }
    }
  }
`;

export interface IChangeHostResponse {
  changeClientSessionHost: {
    id: number;
    hosts: Array<{
      host: { id: number; counters: { active_window: string } };
    }>;
  };
}
export const CHANGE_HOST = gql`
  mutation changeClientSessionHost(
    $id: Int!
    $input: ChangeClientSessionHostInput!
  ) {
    changeClientSessionHost(id: $id, input: $input) {
      id
      hosts {
        host {
          id
          counters {
            active_window
          }
        }
      }
    }
  }
`;

export interface FreeHostsResponse {
  freeHosts: {
    alias: string;
    id: number;
    group: {
      id: number;
      title: string;
      priority: number;
    };
    position: number;
  }[];
}

export interface FreeHostsRequest {
  host_id: number;
}

export const FREE_HOSTS = gql`
  query freeHosts($host_id: Int!) {
    freeHosts(host_id: $host_id) {
      alias
      id
      group {
        id
        title
        priority
      }
      position
    }
  }
`;
